import { useLocation } from 'react-router-dom'
import MessageCard from '../MessageCard/MessageCard'

export default function RouteNotFound() {
  console.log('RouteNotFound rendered')

  let location = useLocation()
  console.log(location)
  const message = `"${location.pathname}" is no longer a valid bookmark for CaseEnsemble 2.0.  Please log into the system and update your bookmark.`
  
  return (
    <MessageCard
      title="Invalid Bookmark"
      message={message}
      buttonText="Go To Login"
      clickUrl="/login"
    />
  )
}
